import { render, staticRenderFns } from "./VolPersonLogin.vue?vue&type=template&id=6186d723"
import script from "./VolPersonLogin.vue?vue&type=script&lang=js"
export * from "./VolPersonLogin.vue?vue&type=script&lang=js"
import style0 from "./VolPersonLogin.vue?vue&type=style&index=0&id=6186d723&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports